import uuid from './uuid';

// Look in local storage to see if a client wants to preserve its id
let clientId = window.localStorage.getItem('xc-next-clientid-cap');

// None in local storage so just generate a new one
!clientId && (clientId = uuid);

// We always remove the stored id here so there is no chance of two instances using it
window.localStorage.removeItem('xc-next-clientid-cap');
export default clientId;


// WEBPACK FOOTER //
// ./src/utils/clientid.js